import { CircularProgress } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import * as LocksActions from '../../../redux/actions/lock.actions';
import WarningOutlineIconCustom from '../../CustomIcons/WarningOutlineIconCustom';
import MDButton from '../../MDButton/MDButton';
import SelectableField from '../Fields/SelectableInput/SelectableField';
import { RED } from '../../../_config/consts';


const validate = (values) => {
  const errors = {};
  if (values) {
    if (!values.lockTags || (values.lockTags && _.isEmpty(values.lockTags))) {
      errors.lockTags = 'required';
    }
  }

  return errors;
};

@reduxForm({ form: 'AddLocksToGatewayForm', validate })
@connect(state => ({ form: state.form.AddLocksToGatewayForm }))
class AddLocksToGatewayForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      locksOptions: [],
      lockSelected: null,
    };
  }
  async componentDidMount() {
    this.onFetchLocksAndSetOptions();
  }

  async onFilterLocksTags(name) {
    const { dispatch } = this.props;
    dispatch(LocksActions.setFilter('name', name));
    this.onFetchLocksAndSetOptions();
  }

  async onFetchLocksAndSetOptions() {
    const { dispatch, items } = this.props;
    const tags = await dispatch(LocksActions.fetchLocks());
    const options = _.map(tags, tag => ({ value: tag, label: tag.name }));
    const locksOptions = _.filter(options, smartLockOption => !_.find(items, { id: smartLockOption.value.id }));
    this.setState({ locksOptions });
  }

  onSelectLock(lock) {
    if (lock && lock.value) {
      this.setState({ lockSelected: lock.value });
    }
  }

  onAddLockToGateway(lock) {
    const { dispatch, onAddLockToGateway } = this.props;
    if (onAddLockToGateway) {
      onAddLockToGateway(lock);
      this.setState({ lockSelected: null });
    }
  }

  render() {
    const {
      dispatch,
      isListLoading,
      locksToExclude,
      isGatewayOffline,
    } = this.props;
    const { locksOptions, lockSelected } = this.state;
    const locksOptionsFiltered = _.filter(locksOptions, lock => !_.find(locksToExclude, { id: lock.value.id }));
    const isButtonDisabled = !lockSelected || isGatewayOffline;
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Field
            name="lockTagSelectedSearch"
            component={SelectableField}
            noCache
            options={locksOptionsFiltered}
            placeholder={<Entity entity="findLockToAdd" />}
            containerstyle={{ minWidth: 480, marginRight: 10 }}
            onInputChange={value => this.onFilterLocksTags(value)}
            onSelect={tagData => this.onSelectLock(tagData)}
          />
          <MDButton
            disabled={isButtonDisabled}
            title={<Entity entity="addLockToGateway" />}
            containerStyle={{ borderRadius: 5, margin: 0, marginLeft: 10, opacity: isButtonDisabled ? 0.5 : 1 }}
            onClick={() => this.onAddLockToGateway(lockSelected)}
          />
          {isGatewayOffline ? (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <WarningOutlineIconCustom style={{ marginLeft: 10, width: 20, color: RED }} />
              <h4 style={{ fontSize: 18, margin: 0, marginLeft: 5, color: RED }}>
                <Entity entity="gatewayIsOffline" />
              </h4>
            </div>
          ) : null}
          {isListLoading ? <CircularProgress /> : null}
        </div>
    );
  }
} 

export default AddLocksToGatewayForm;
